import React, { PureComponent } from 'react';
import { Form, Slider, Button } from 'antd';
import { services } from '@comall-backend-builder/core';
import { language } from '../../../language';
import { EntryList, FormItemLayout, ConfigFormDecorator } from '../../tools';
import { ImageAdItem } from './image-ad-item';
import { ImageAdTips } from './image-ad-tips';

const FormItem = Form.Item;

const MAX_ENTRY_COUNT = 10;
const interpolate = services.interpolate;

const templates = [
    {
        id: '1',
        name: '一行一个',
        left: '0px',
    },
    {
        id: '2',
        name: '一行两个',
        left: '20px',
    },
    {
        id: '3',
        name: '一行三个',
        left: '20px',
    },
    {
        id: '4',
        name: '一行四个',
        left: '20px',
    },
];

/**
 * 图文组件-配置表单
 */
class StaticPictureCom extends PureComponent<any> {
    WrapImageAdItem = (props) => {
        const { uploadAction, selector, sourceRoot } = this.props;
        return (
            <ImageAdItem
                {...props}
                sourceRoot={sourceRoot}
                selector={selector}
                uploadAction={uploadAction}
            />
        );
    };

    handleClickTemplates = (id: string) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();
        onChange({ ...formValue, showStyle: id });
    };

    render() {
        const {
            form: { getFieldDecorator },
            value,
            linkTypes,
            linkTypeMode,
        } = this.props;
        const formItemLayout = FormItemLayout;
        const tmpIndex = value.showStyle || '1';
        return (
            <Form className="editor-image-ad">
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.ImageAd.selectTemplate')}
                >
                    {[
                        getFieldDecorator('showStyle', {}),
                        templates.map((item) => (
                            <Button
                                type={tmpIndex === item.id ? 'primary' : 'default'}
                                shape="round"
                                style={{ marginLeft: item.left }}
                                key={item.id}
                                onClick={() => this.handleClickTemplates(item.id)}
                            >
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>

                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.ImageAd.pageMargin')}
                >
                    {getFieldDecorator('margin')(<Slider max={48} min={0} />)}
                </FormItem>

                {
                    <FormItem
                        {...formItemLayout}
                        label={language.getText('components.ImageAd.imageMargin')}
                    >
                        {getFieldDecorator('marginImage')(<Slider max={48} min={0} />)}
                    </FormItem>
                }
                {
                    <FormItem
                        {...formItemLayout}
                        label={language.getText('components.ImageAd.borderRadius')}
                    >
                        {getFieldDecorator('borderRadius')(<Slider max={48} min={0} />)}
                    </FormItem>
                }

                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapImageAdItem}
                            renderTips={ImageAdTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.ImageAd.tips'), {
                        max: MAX_ENTRY_COUNT,
                    })}
                </p>
            </Form>
        );
    }
}

export const StaticPicture = ConfigFormDecorator(StaticPictureCom);
